import Wprr from "wprr";
import React from "react";


export default class DoublePromo extends Wprr.BaseObject {
	
	_construct() {
		super._construct();
	}

	_renderMainElement() {
		
		let title1 = this.getFirstInput("title", Wprr.sourceReference("blockData", "title1"));
		let text1 = this.getFirstInput("text", Wprr.sourceReference("blockData", "text1"));
		let image1 = this.getFirstInput(Wprr.sourceReference("blockData", "image1.url"));
		let imageLabel1 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "imageLabel1"));
		let linkUrl1 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "link1.url"));
		let linkLabel1 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "link1.label"));

		let title2 = this.getFirstInput("title", Wprr.sourceReference("blockData", "title2"));
		let text2 = this.getFirstInput("text", Wprr.sourceReference("blockData", "text2"));
		let image2 = this.getFirstInput(Wprr.sourceReference("blockData", "image2.url"));
		let imageLabel2 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "imageLabel2"));
		let linkUrl2 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "link2.url"));
		let linkLabel2 = this.getFirstInput("textAfterButton", Wprr.sourceReference("blockData", "link2.label"));
		
		let mobileLayout = <div className="centered-site">
			<Wprr.Link href={linkUrl1} className="custom-styled-link">
				<div className="text-and-image text-and-image-text-box-padding">
					<h2 className="no-margins text-uppercase text-and-image-title">
						{Wprr.text(title1)}
					</h2>
					<Wprr.HasData check={text1}>
						<div className="spacing medium" />
						<div className="text-and-image-text wp-rich-text-formatting">
							{Wprr.text(text1, "html")}
						</div>
					</Wprr.HasData>
					<div className="spacing medium" />
					<div className="absolute-container ratio-16-9">
						<Wprr.Image className="background-cover full-size" src={image1} />
						<Wprr.HasData check={imageLabel1}>
							<div className="position-absolute promo-image-label promo-image-label-position standard-text-color">
								{Wprr.text(imageLabel1)}
							</div>
						</Wprr.HasData>
					</div>
					
					<Wprr.HasData check={linkLabel1}>
						<div className="spacing standard" />
						<Wprr.FlexRow>
							<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel1} />
						</Wprr.FlexRow>
					</Wprr.HasData>
				</div>
			</Wprr.Link>
			<div className="spacing standard" />
			<Wprr.Link href={linkUrl2} className="custom-styled-link">
				<div className="text-and-image text-and-image-text-box-padding">
					<h2 className="no-margins text-uppercase text-and-image-title">
						{Wprr.text(title2)}
					</h2>
					<Wprr.HasData check={text1}>
						<div className="spacing medium" />
						<div className="text-and-image-text wp-rich-text-formatting">
							{Wprr.text(text2, "html")}
						</div>
					</Wprr.HasData>
					<div className="spacing medium" />
					<div className="absolute-container ratio-16-9">
						<Wprr.Image className="background-cover full-size" src={image2} />
						<Wprr.HasData check={imageLabel2}>
							<div className="position-absolute promo-image-label promo-image-label-position standard-text-color">
								{Wprr.text(imageLabel2)}
							</div>
						</Wprr.HasData>
					</div>
					
					<Wprr.HasData check={linkLabel2}>
						<div className="spacing standard" />
						<Wprr.FlexRow>
							<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel2} />
						</Wprr.FlexRow>
					</Wprr.HasData>
				</div>
			</Wprr.Link>
		</div>;
		
		
		let desktopLayout = <div className="centered-site">
			<Wprr.FlexRow className="big-item-spacing" itemClasses="width-50,width-50">
				<Wprr.Link href={linkUrl1} className="custom-styled-link">
					<div className="text-and-image text-and-image-text-box-padding">
						<h2 className="no-margins text-uppercase text-and-image-title">
							{Wprr.text(title1)}
						</h2>
						<Wprr.HasData check={text1}>
							<div className="spacing medium" />
							<div className="text-and-image-text wp-rich-text-formatting">
								{Wprr.text(text1, "html")}
							</div>
						</Wprr.HasData>
					</div>
				</Wprr.Link>
				<Wprr.Link href={linkUrl2} className="custom-styled-link">
					<div className="text-and-image text-and-image-text-box-padding">
						<h2 className="no-margins text-uppercase text-and-image-title">
							{Wprr.text(title2)}
						</h2>
						<Wprr.HasData check={text1}>
							<div className="spacing medium" />
							<div className="text-and-image-text wp-rich-text-formatting">
								{Wprr.text(text2, "html")}
							</div>
						</Wprr.HasData>
					</div>
				</Wprr.Link>
			</Wprr.FlexRow>
			<div className="spacing medium" />
			<Wprr.FlexRow className="big-item-spacing" itemClasses="width-50,width-50">
				<Wprr.Link href={linkUrl1} className="custom-styled-link">
					<div className="text-and-image text-and-image-text-box-padding">
						<div className="absolute-container ratio-16-9">
							<Wprr.Image className="background-cover full-size" src={image1} />
							<Wprr.HasData check={imageLabel1}>
								<div className="position-absolute promo-image-label promo-image-label-position standard-text-color">
									{Wprr.text(imageLabel1)}
								</div>
							</Wprr.HasData>
						</div>
						
						<Wprr.HasData check={linkLabel1}>
							<div className="spacing standard" />
							<Wprr.FlexRow>
								<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel1} />
							</Wprr.FlexRow>
						</Wprr.HasData>
					</div>
				</Wprr.Link>
				<Wprr.Link href={linkUrl2} className="custom-styled-link">
					<div className="text-and-image text-and-image-text-box-padding">
						<div className="absolute-container ratio-16-9">
							<Wprr.Image className="background-cover full-size" src={image2} />
							<Wprr.HasData check={imageLabel2}>
								<div className="position-absolute promo-image-label promo-image-label-position standard-text-color">
									{Wprr.text(imageLabel2)}
								</div>
							</Wprr.HasData>
						</div>
						
						<Wprr.HasData check={linkLabel2}>
							<div className="spacing standard" />
							<Wprr.FlexRow>
								<Wprr.layout.interaction.Button className="standard-button standard-button-hover standard-button-padding cursor-pointer" text={linkLabel2} />
							</Wprr.FlexRow>
						</Wprr.HasData>
					</div>
				</Wprr.Link>
			</Wprr.FlexRow>
		</div>;
		
		let responsiveLayout = Wprr.creators.responsiveTemplate(mobileLayout);
		responsiveLayout.addResponsiveTemplate(desktopLayout, 860);
		
		return <React.Fragment>
			{responsiveLayout.getReactElements()}
		</React.Fragment>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return <Wprr.layout.admin.WpBlockEditor dataSettings={dataSettings}>
			<div>
				<Wprr.layout.form.LabelledArea label="Title 1">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "title1")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Text 1">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="text1" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Image 1">
					<Wprr.wp.blocks.editor.ImageSelection valueName="image1" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Imaage label 1">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "imageLabel1")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Link 1">
					<Wprr.wp.blocks.editor.Link valueName="link1" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<div className="spacing standard" />
				<Wprr.layout.form.LabelledArea label="Title 2">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "title2")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Text 2">
					<Wprr.wp.blocks.editor.RichTextEditor valueName="text2" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Image 2">
					<Wprr.wp.blocks.editor.ImageSelection valueName="image2" />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Imaage label 2">
					<Wprr.FormField value={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage", "imageLabel2")} />
				</Wprr.layout.form.LabelledArea>
				<Wprr.layout.form.LabelledArea label="Link 2">
					<Wprr.wp.blocks.editor.Link valueName="link2" externalStorage={Wprr.sourceReference("wprr/wpBlockEditor/externalStorage")} />
				</Wprr.layout.form.LabelledArea>
			</div>
		</Wprr.layout.admin.WpBlockEditor>;
	}
}